import React from 'react';
import BaseGridToolbar from '../shared/toolbar/BaseGridToolbar';
import ToolbarButton from '../shared/toolbar/ToolbarButton';

const UploadButton = ({ onClick }) => (
  <ToolbarButton
    variant="contained"
    onClick={onClick}
    startIcon={
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
      </svg>
    }
  >
    Upload Document
  </ToolbarButton>
);

const DocumentToolbar = ({ columns, onUploadClick, ...props }) => {
  return (
    <BaseGridToolbar
      title="Documents"
      columns={columns}
      actionButton={<UploadButton onClick={onUploadClick} />}
      {...props}
    />
  );
};

export default React.memo(DocumentToolbar);
